import '../../components/Category/Card/CategoryCard.css';
import './VodaPayClubPage.css';
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import VodaPayClubTicket from '../../assets/VodaPayClubTicket.jsx';
import ChevronRightIcon from '../../assets/ChevronRight.jsx';
import CategoryVendors from '../../components/Category/Vendors/CategoryVendors.jsx';
import CategoryVouchers from '../../components/Category/Vouchers/CategoryVouchers.jsx';
import { CategoriesContext } from '../../services/context/CategoriesContext.js';
import { defaultAnalyticsVariables, events, pagePrefix } from '../../services/Constants/Analytics.js';
import { SubscriptionDetailsContext } from '../../services/context/SubscriptionDetailsContext.js';
import useNormalizedSubscriptionStatus from '../../services/utils/subscriptionUtils.js';
import MoneyIcon from '../../assets/MoneyIcon.jsx';

/**
 * @returns {JSX.Element} VodaPayClubPage component
 */
export default function VodaPayClubPage() {
  const analyticsName = `${pagePrefix}: manage subscription`;
  const navigateTo = useNavigate();
  const categories = useContext(CategoriesContext);
  const category = categories?.find(element => element.isClubCategory === true);
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const subscriptionStatus = useNormalizedSubscriptionStatus();
  const isSubscriptionCancelled = subscriptionDetails?.data?.isCancelled;
  const subscriptionsExpirationDate = moment.utc(subscriptionDetails?.data?.expirationDate).format('DD-MM-YYYY');
  const totalSavings = localStorage.getItem('totalSavings') || undefined;
  const errorMessage = localStorage.getItem('totalSavings-error') || undefined;

  useEffect(() => {
    window.utag?.view({
      ...defaultAnalyticsVariables,
      event_name: [events.pageView],
      page_name: analyticsName,
      link_id: `${pagePrefix}: cancel subscription`,
      visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatus}`,
    });
  }, []);

  const onClickAnalytics = () => {
    window.utag?.link({
      ...defaultAnalyticsVariables,
      event_name: [events.interaction],
      page_name: analyticsName,
      link_id: `${pagePrefix}: cancel subscription`,
      visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatus}`,
    });
  };

  return (
    <div className='top-container'>
      <div className='image-container'>
        <VodaPayClubTicket />
      </div>
      <h2 className='title'>Your VodaPay Club Membership</h2>
      {
        isSubscriptionCancelled ? <span className='validity'>Membership valid until: {subscriptionsExpirationDate}</span>
          : <>
            <h3 className='sub-title'> You&apos;re in and ready to get more value</h3>
            <button
              className='manage-button-style'
              onClick={
                () => {
                  navigateTo(ROUTES.ARE_YOU_SURE);
                  onClickAnalytics();
                }
              }
            >Cancel membership <ChevronRightIcon />
            </button>
          </>
      }
      {
        subscriptionDetails?.isSubscribed
        && <section className='advance container-v'>
          {
            errorMessage
              ? <div className='value-row'>
                <MoneyIcon />
                <p className='error-description'>
                  { errorMessage }
                </p>
              </div>
              : <div className='value-row'>
                <MoneyIcon />
                <p className='saving-amount'>{totalSavings}</p>
                <p className='description'>
                  Total extra value since you joined the club
                </p>
              </div>
          }
        </section>
      }
      <CategoryVendors category={ category } />
      <CategoryVouchers category={ category } />
    </div>
  );
}
